import { VendorDTO } from "../DTO/vendorDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateVendorRequest extends BasicRequest{
    
    public vendor! : VendorDTO;

    constructor(){
        super();
    }
}